import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// the translations
import resources from './locales'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    ns: ['common'],
    defaultNS: 'common',
    lng: 'en',

    keySeparator: false, // we do not use keys in form messages.welcome
    returnEmptyString: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
